import SitesStore from "../stores/internal/SitesStore";
import { toJS } from "mobx";

export const getAllSites = () => toJS(SitesStore.sites);
export const getSiteById = (site_id) => {
  return toJS(SitesStore.siteById[site_id])
}
export const getSiteAnalyticsById = (site_id) => toJS(SitesStore.site_analytics[site_id])
export const getSiteAnalyticsV2ByIdAndRange = (site_id, date_range) => {
  if (!SitesStore.site_analytics_v2[site_id]) {
    return undefined;
  }
  return toJS(SitesStore.site_analytics_v2[site_id][date_range])
}
export const getSiteTrendingByIdAndRange = (site_id, date_range) => {
  if (!SitesStore.site_trending[site_id]) {
    return undefined;
  }
  return toJS(SitesStore.site_trending[site_id][date_range])
}
export const getLiteSiteAnalyticsByIdAndRange = (site_id, date_range) => {
  if (!SitesStore.site_analytics_lite[site_id]) {
    return undefined;
  }
  const found =  toJS(SitesStore.site_analytics_lite[site_id][date_range]);
  return found;
}
export const getSiteInvoiceReportById = (site_id) => toJS(SitesStore.site_invoice_reports[site_id])
export const getSiteSubscriptionById = (site_id) => toJS(SitesStore.site_subscriptions[site_id])
export const getSiteContentById = (site_id) => toJS(SitesStore.site_content[site_id]);
export const getSiteContentByTrackingId = (tracking_id) => toJS(SitesStore.site_content_article[tracking_id]);
export const getSiteHoursReportByIdAndTime = (site_id, offset) => {
  if (!SitesStore.site_hour_reports[site_id]) {
    return undefined;
  }
  return toJS(SitesStore.site_hour_reports[site_id][`${offset}`])
}
export const getSiteSubmissionsById = (site_id) => toJS(SitesStore.site_submissions[site_id])
export const getSiteBillingPortalById = (site_id) => toJS(SitesStore.site_billing_portal[site_id])